import { render, staticRenderFns } from "./OpenPurchasesSummary.vue?vue&type=template&id=a86d77b2&"
import script from "./OpenPurchasesSummary.vue?vue&type=script&lang=js&"
export * from "./OpenPurchasesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports